/*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/

import axios from 'axios';
import update from 'immutability-helper';

String.prototype.rtrim = function () {
  return this.replace(/((\s*\S+)*)\s*/, '$1');
};

String.prototype.ltrim = function () {
  return this.replace(/\s*((\S+\s*)*)/, '$1');
};

export const textEllipsis = (text, firstDigit = 10, lastDigit = 0) => {
  if (!text) {
    return '';
  }

  const safeText = String(text);
  const safeFirstDigit = Math.max(0, firstDigit);
  const safeLastDigit = Math.max(0, lastDigit);

  const isFullHtmlEntity = (value) => {
    return /^&(?:#\d+|#x[a-fA-F0-9]+|[a-zA-Z][a-zA-Z0-9]+);$/.test(value);
  };

  const adjustRightBoundary = (value, index) => {
    let nextIndex = Math.min(Math.max(0, index), value.length);

    // Avoid cutting surrogate-pair symbols in half.
    if (
      nextIndex > 0 &&
      nextIndex < value.length &&
      /[\uD800-\uDBFF]/.test(value[nextIndex - 1]) &&
      /[\uDC00-\uDFFF]/.test(value[nextIndex])
    ) {
      nextIndex += 1;
    }

    const ampIndex = value.lastIndexOf('&', nextIndex - 1);
    if (ampIndex !== -1) {
      const semicolonIndex = value.indexOf(';', ampIndex);
      if (semicolonIndex !== -1 && semicolonIndex >= nextIndex) {
        const entity = value.slice(ampIndex, semicolonIndex + 1);
        if (isFullHtmlEntity(entity)) {
          nextIndex = semicolonIndex + 1;
        }
      }
    }

    return nextIndex;
  };

  const adjustLeftBoundary = (value, index) => {
    let nextIndex = Math.min(Math.max(0, index), value.length);

    // Avoid cutting surrogate-pair symbols in half.
    if (
      nextIndex > 0 &&
      nextIndex < value.length &&
      /[\uD800-\uDBFF]/.test(value[nextIndex - 1]) &&
      /[\uDC00-\uDFFF]/.test(value[nextIndex])
    ) {
      nextIndex -= 1;
    }

    const ampIndex = value.lastIndexOf('&', nextIndex - 1);
    if (ampIndex !== -1) {
      const semicolonIndex = value.indexOf(';', ampIndex);
      if (semicolonIndex !== -1 && semicolonIndex >= nextIndex) {
        const entity = value.slice(ampIndex, semicolonIndex + 1);
        if (isFullHtmlEntity(entity)) {
          nextIndex = ampIndex;
        }
      }
    }

    return nextIndex;
  };

  const firstBoundary = adjustRightBoundary(safeText, safeFirstDigit);
  const lastStartBoundary = adjustLeftBoundary(safeText, safeText.length - safeLastDigit);

  const firstText = safeText.substring(0, firstBoundary);
  const lastText = safeLastDigit ? safeText.substring(lastStartBoundary) : '';

  if (safeText.length > firstText.length + lastText.length) {
    return `${firstText.rtrim()}...${lastText.ltrim()}`;
  } else {
    return safeText;
  }
};

export function replaceRefToInneRef(obj) {
  const oldRef = obj.ref;
  delete obj.ref;
  return {
    ...obj,
    innerRef: oldRef
  };
}

export const tokenRetrievalRequest = () => {
  return axios.get(`${process.env.REACT_APP_PUBLIC_DOMAIN}/sanctum/csrf-cookie`, {
    withCredentials: true
  });
};

export const getImage = (path) => {
  return `${process.env.REACT_APP_PUBLIC_IMAGES_S3}/${path}`;
};

export const getSurveyUrl = (id, status = null) => {
  let baseUrl;

  if (window.location.hostname !== process.env.REACT_APP_CLIENT_PORTAL_DOMAIN) {
    baseUrl = process.env.REACT_APP_WHITE_LABEL_FRONTPAGE;

    if (status !== 'PUBLISHED' || status === null) {
      baseUrl = process.env.REACT_APP_WHITE_LABEL_PREVIEW_FRONTPAGE;
    }
  } else {
    baseUrl = process.env.REACT_APP_FRONTPAGE;

    if (status !== 'PUBLISHED' || status === null) {
      baseUrl = process.env.REACT_APP_PREVIEW_FRONTPAGE;
    }
  }

  return `${baseUrl}/${id}`;
};

export const emailsCommaSeparatedToArray = (emailString) => {
  return emailString
    .split(',')
    .map((email) => email.ltrim().rtrim())
    .filter(function (el) {
      return el !== '';
    });
};

export const viewSurveyTitle = (isPublished, isTemplate = false) => {
  if (isPublished) return `Share & Preview ${isTemplate ? 'Template' : ''}`;
  return `Preview ${isTemplate ? 'Template' : ''}`;
};

export const removeHtmlTags = (text) => {
  return text?.replace(/(<([^>]+)>)/gi, '').replaceAll('&nbsp;', '');
};

export const reSortingData = (currentDatas, currentIndex, nextIndex) => {
  return update(currentDatas, {
    $splice: [
      [currentIndex, 1],
      [nextIndex, 0, currentDatas[currentIndex]]
    ]
  });
};

export function cleanQueryString(queryString) {
  return queryString.startsWith('?') ? queryString.slice(1) : queryString;
}

export function getSubdomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (hostname !== process.env.REACT_APP_CLIENT_PORTAL_DOMAIN) {
    return parts[0];
  }

  return null;
}
